module.exports = __webpack_public_path__ + "img/whatsapp.d7107041.svg";